import { createServerFn } from '@tanstack/react-start'
import { z } from 'zod'
import { requireSupabaseAuth } from '@/integrations/supabase/auth-middleware'

// Account emails. The recipient is always the signed-in user's own address.

export const sendWelcomeEmail = createServerFn({ method: 'POST' })
  .middleware([requireSupabaseAuth])
  .inputValidator((data) => z.object({ name: z.string().max(200).optional() }).parse(data))
  .handler(async ({ data, context }) => {
    const email = (context.claims as { email?: string }).email
    if (!email) return { sent: false }
    const { sendAndLog } = await import('./app-email.server')
    return sendAndLog('welcome', email, {
      templateData: { name: data.name },
      idempotencyKey: `welcome-${context.userId}`,
    })
  })

export const sendPasswordChangedEmail = createServerFn({ method: 'POST' })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const email = (context.claims as { email?: string }).email
    if (!email) return { sent: false }
    const { sendAndLog } = await import('./app-email.server')
    return sendAndLog('password-changed', email, {
      idempotencyKey: `pw-changed-${context.userId}-${Date.now()}`,
    })
  })
